import Type4 from "./Type4";

export default Type4;
